/**
 * Page dictionary - English
 * Batch 6: Cloud address book (Contacts/index) - spreadsheet import/export
 */
export default {
  '云端通讯录': 'Cloud address book',
  '通讯录总人数': 'Total contacts',
  '平台用户': 'Platform user',
  '已注册': 'Registered',
  '未注册': 'Not registered',
  '全球ID': 'Global ID',
  '来源': 'Source',
  '导入 CSV': 'Import CSV',
  '导出 CSV': 'Export CSV',
  '下载模板': 'Download template',
  '新增联系人': 'Add contact',
  '编辑联系人': 'Edit contact',
  '确认删除？': 'Delete this contact?',
  '多个标签用逗号分隔': 'Separate multiple tags with commas',
  '导入成功': 'Import successful',
  '导入失败': 'Import failed',
  '导出成功': 'Export successful',
  '导出失败': 'Export failed',
  '保存成功': 'Saved',
  '保存失败': 'Save failed',
  '已删除': 'Deleted',
  '删除失败': 'Delete failed',
};
